<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="piaoCon">
            <div class="tickets">
                <div class="ttitle">
                    票种信息
                </div>
                <div class="ticketTable flx">
                    <div class="ticketpart" style="width: 372px;">
                        <div class="ticketTitle">
                            活动时间
                        </div>
                        <div class="ticketDe" v-text="info.time"></div>
                    </div>

                    <div class="ticketpart" style="width:408px;">
                        <div class="ticketTitle">
                            票种名称
                        </div>
                        <div class="ticketDe" v-text="info.spec_name?info.spec_name:info.name"></div>
                    </div>

                    <div class="ticketpart" style="width: 177px;">
                        <div class="ticketTitle">
                            单价
                        </div>
                        <div class="ticketDe" v-text="info.goods_price"></div>
                    </div>

                    <div class="ticketpart" style="width: 262px;">
                        <div class="ticketTitle">
                            数量
                        </div>
                        <div class="ticketDe" v-text="info.num"></div>
                    </div>

                    <div class="ticketpart" style="width: 177px;border: none;">
                        <div class="ticketTitle">
                            小计
                        </div>
                        <div class="ticketDe" v-text="info.num * info.goods_price"></div>
                    </div>
                </div>
            </div>

            <div class="tickets">
                <div class="ttitle">
                    填写报名信息
                </div>
                <div class="signInfo">
                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>姓名</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入姓名" v-model="member.name">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>手机号</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入手机号" v-model="member.tel">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>邮箱</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入邮箱" v-model="member.email">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>企业名称</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入企业名称" v-model="member.company_name">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>岗位职务</span>
                        </div>
                        <div class="ips">
                            <div class="inps" style="width: 500px;">
                                <el-select v-model="member.position_name" placeholder="请选择岗位职务">
                                    <el-option v-for="item in col1" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>行业类型</span>
                        </div>
                        <div class="ips">
                            <div class="inps" style="width: 500px;">
                                <el-select v-model="member.industry_name" placeholder="请选择行业类型">
                                    <el-option v-for="item in col2" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>所在地区</span>
                        </div>
                        <div class="ips">
                           <el-cascader style="width: 500px;" v-model="areaValue" :options="areaList"
                                :props="areaProps" :placeholder="areaValue.length > 0?fullName : '请选择省/市/区'" clearable
                                @change="handleAreaChange"></el-cascader>
                        </div>
                    </div>
                    <div class="formitem flx" v-if="info.bg_status.includes('5')" >
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>填写需求</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input :rows="6" maxlength="2000" :show-word-limit="true" type="textarea"
                                    resize="none" count placeholder="请输入需求" v-model="member.demand">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc" v-if="info.bg_status.includes('7')" >
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>身份证明</span>
                        </div>
                        <div class="ips">
                            <el-upload class="upload-demo" action="https://hrxsl.com/api/Common/oss_upload"
                                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                                :headers="uploadHeaders" :show-file-list="false">
                                <div class="upimage">
                                    <img v-if="!member.id_img" :src="$Localimg('gup.png')" alt="" />
                                    <img v-else :src="$img(member.id_img)" alt="" />
                                </div>
                            </el-upload>
                        </div>
                    </div>


                    <div class="formitem flx alc" v-if="info.bg_status.includes('1')" >
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>推荐人姓名</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入推荐人姓名" v-model="member.promoter">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc"  v-if="info.bg_status.includes('4')">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>微信</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入微信号" v-model="member.wx_number">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc" v-if="info.bg_status.includes('3')">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>QQ</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入QQ号" v-model="member.qq">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc" v-if="info.bg_status.includes('2')" >
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>学历</span>
                        </div>
                        <div class="ips">
                            <div style="width: 500px;">
                                <el-input placeholder="请输入学历" v-model="member.ed">
                                </el-input>
                            </div>
                        </div>
                    </div>

                    <div class="formitem flx alc" v-if="info.bg_status.includes('6')">
                        <div class="finame">
                            <span style="color: #FF4949;">*</span>
                            <span>性别</span>
                        </div>
                        <div class="ips">
                            <div>
                                <el-radio v-model="member.sex" label="1">男</el-radio>
                                <el-radio v-model="member.sex" label="2">女</el-radio>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flx jsc">
                    <el-button class="signup" type="primary" @click="signupAc">立即报名</el-button>
                </div>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span v-text="errorword"></span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="tosign">确 定</el-button>
            </span>
        </el-dialog>
        <wechatpay v-if="showALert" @close="showALert=false" :type="'activity'" :source="'order'" :orderNo="orderNo" :codeUrl="codeUrl"></wechatpay>
    </div>
</template>

<script>
    import {
        signpage,
        getRIndex,
        getSignInfo,
        signAc,
        checkorderpay
    } from "@/api/index.js"
    import wechatpay from "@/components/wechatpay.vue"
    import areaList from '@/assets/area.json'
   
    export default {
        components: {
            wechatpay
        },
        data() {
            return {
                codeUrl:"",
                orderNo: "",
                showALert: false,
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
                id: "",
                channel_id: "",
                num: 1,
                ticket_id: "",
                info: {},
                col1: [],
                col2: [],
                member: {},
                areaList: areaList,
                errorword: "",
                areaProps: {
                    value: 'label',
                    label: 'label',
                    children: 'children'
                },
                accate: [],
                areaValue: [],
                radio: '1',
                dialogVisible: false,
                info: {
                    bg_status: ""
                }
            }
        },
        created() {
            let that = this
            let data = {}
            data.activity_id = that.$route.query.id
            data.num = 1
            data.spec_id = that.$route.query.spec_id
            signpage(data).then((res) => {
                console.log('page', res)
                if (res.code == -1) {
                    that.errorword = res.msg
                    console.log(that.errorword)
                    that.dialogVisible = true
                }
                if (res.code == 1) {
                    that.info = res.data
                    that.$nextTick(() => {
                        window.scrollTo(0, 0)
                    })
                    that.getSignInfo()
                }
            })

        },
        mounted() {
            let that = this
            getRIndex().then((res) => {
                if (res.code == 1) {
                    that.col1 = res.data.where_category[2].list
                    that.col2 = res.data.where_category[5].list
                }
            })
        },
        beforeDestroy() {
            if (this.pollTimer) clearInterval(this.pollTimer)
        },
        methods: {
            tosign() {
                this.$router.push({
                    path: '/mine', // 写路由path
                    query: {
                        type: 'info'
                    }
                })
            },
            checkOrderpay() {
                let that = this
                let data = that.orderNo
                checkorderpay(data).then((res) => {
                    if (res.code == 1) {
                        if (res.data.is_pay_ok == 1) {
                            that.$message.success('支付成功')
                            setTimeout(() => {
                                that.$router.push('/punSuccess')
                            }, 2000)
                        } else {
                            that.$message.warning('暂未查询到订单支付结果，请稍后再试')
                        }

                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            signupAc() {
                console.log(this.member)
                let that = this
                let data = {}
                let t = []
                t.push(that.member)
                data.activity_id = that.$route.query.id
                data.num = 1
                data.spec_id = that.$route.query.spec_id
                data.channel_id = that.$route.query.channel_id || ''
                data.activityRegistration = JSON.stringify(t)
                console.log(data)
                signAc(data).then((res) => {
                    if (res.code == 1) {
                        if (res.data.is_pay === 0) {
                            // that.$message.success(res.msg)
                            setTimeout(() => {
                                that.$router.push({
                                    path: '/homeSuccess', // 写路由path
                                    query: {
                                        txt:'恭喜您，报名成功!'
                                    }
                                })
                            }, 2000)
                        } else {
                            that.orderNo = res.data.order_no
                            that.codeUrl = res.data.code_url
                            that.showALert = true
                            console.log(that.showALert)
                        }

                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            handleAvatarSuccess(e) {
                let that = this
                if (e.code == 1) {
                    that.member.id_img = e.data.url
                } else {
                    this.$message.error(e.data.msg)
                }
            },
            beforeAvatarUpload(file) {
                // 1. 允许的图片格式
                const allowType = ['image/png', 'image/jpg', 'image/jpeg']
                // 2. 最大8MB
                const maxSize = 8 * 1024 * 1024

                // 校验格式
                if (!allowType.includes(file.type)) {
                    this.$message.error('仅支持 png、jpg、jpeg 格式图片！')
                    return false
                }

                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('图片不能大于8MB！')
                    return false
                }

                // 校验通过，允许上传
                return true
            },
            handleAreaChange(e) {
                console.log(e)
                console.log(this.areaValue)
                this.member.address = this.areaValue[0] + "_" + this.areaValue[1]
            },
            getSignInfo() {
                let that = this
                getSignInfo().then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        let obj = {}
                        obj.name = res.data.name
                        obj.tel = res.data.tel
                        obj.email = res.data.email
                        obj.company_name = res.data.company_name
                        obj.industry_type = res.data.industry_type
                        obj.industry_name = res.data.industry_name
                        obj.position = res.data.position
                        obj.position_name = res.data.position_name
                        obj.sex_name = res.data.sex_name
                        obj.address = res.data.address
                        obj.id_img = res.data.id_img
                        obj.qq = res.data.qq
                        obj.wx_number = res.data.wx_number
                        obj.promoter = res.data.promoter || ''
                        obj.demand = res.data.demand || ''
                        obj.ed = res.data.ed || ''
                        obj.sex = res.data.sex
                        that.member = obj
                        that.areaValue = res.data.address.split("_")
                        that.fullName = that.areaValue[0] + '/' + that.areaValue[1]
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .qroce {
        width: 200px;
        height: 200px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .qroce img {
        width: 100%;
        height: 100%;
    }

    .mask {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .3);
        z-index: 999 !important;

    }

    .signInfo {
        margin-top: 30px;
    }

    .upimage {
        width: 516px;
        height: 252px;
    }

    .ticketpart {
        border-right: 1px solid #f2f2f2;
    }

    .ticketTable {
        border: 1px solid #F2F2F2;
        margin-top: 31px;
    }

    .signup {
        width: 303px;
        height: 48px;
    }

    .ticketDe {
        height: 85px;
        text-align: center;
        font-size: 14px;
        color: #141933;
        line-height: 85px;
    }

    .ticketTitle {
        height: 32px;
        background: #F2F2F2;
        line-height: 32px;
        font-size: 14px;
        color: #666666;
        text-align: center;
    }

    .ttitle {
        text-align: left;
        font-weight: 600;
        font-size: 18px;
        color: #000;
    }

    .tickets {
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 40px 30px;
        margin-bottom: 16px;
        border-radius: 10px;
    }

    .piaoCon {
        width: 1460px;
        margin: 0 auto;
    }

    .ipll {
        flex: 1;
    }

    .el-cascader .el-input .el-input__inner {
        width: 500px !important;
    }

    .el-select {
        width: 100% !important;
    }

    textarea {
        resize: none !important;
    }

    .bot .el-button {
        width: 209px !important;
        height: 46px !important;
    }

    .rules {
        margin-top: 24px;
    }

    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }

    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }

    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }

    .formitem {
        margin-bottom: 30px;
    }

    .tis .tiitem {
        font-size: 12px;
        color: #838383;
        text-align: left;
        line-height: 24px;
        margin-left: 20px;
    }

    .finame {
        margin-right: 20px;
        font-size: 14px;
        color: #48576A;
        width: 258px;
        text-align: right;
    }

    .ips .inps {
        width: 500px;
        height: 46px;
    }

    .upimage img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .formTitle {
        margin-bottom: 31px;
    }

    .ftname {
        font-weight: 500;
        font-size: 18px;
    }

    .bshu {
        width: 3px;
        height: 16px;
        background: #007AFF;
        margin-right: 12px;
    }

    .forms {
        width: 1460px;
        background-color: #fff !important;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 64px 40px;
    }
</style>